import React, { Component } from 'react';
import RadioInputNew from 'components/RadioInput/indexnew';

class Extras extends Component {
  render() {
    let options = [
      {
        title:
          '180 Aed Refundable Bag Deposit',
        value: 180,
        message: ''
      },
      {
        title:
          'Renewal: already paid bag deposit',
        value: 0,
        message:
          '*Bag Deposit is Mandatory. If not paid, it be charged before start of the plan.'
      }
    ];

    return (
      <section id="extras">
        <div className="goal-heading">
          <div className="goal-number">
            06
          </div>
          <h2>Eco-friendly cooler bag</h2>
          <span>06</span>
        </div>

        <RadioInputNew
          name="bag_price"
          label=""
          datas={options}
          isHorizontal={true}
          value={this.props.bag_price}
          onChange={this.props.onChange}
        />
      </section>
    );
  }
}

export default Extras;
